// extracted by mini-css-extract-plugin
export default {"accessBadge":"access-badge_accessBadge__BvWag"};